import {ErrorRoute} from 'modules/Cart/components/ErrorRoute/ErrorRoute';
import {CartLayout} from 'modules/Cart/containers/CartLayout/CartLayout';
import {CartOffer} from 'modules/Cart/routes/CartOffer/CartOffer';
import {OrderSuccess} from 'modules/Cart/routes/OrderSuccess/OrderSuccess';
import {createBrowserRouter} from 'react-router';

export const router = createBrowserRouter(
    [
        {
            path: '/',
            element: <CartLayout />,
            hydrateFallbackElement: <></>,
            errorElement: <ErrorRoute />,
            children: [
                {
                    index: true,
                    element: <CartOffer />,
                    hydrateFallbackElement: <></>,
                },
                {
                    path: '/submitted/:orderId',
                    element: <OrderSuccess />,
                    hydrateFallbackElement: <></>,
                },
            ],
        },
    ],
    {
        basename:
            process.env.NODE_ENV === 'development'
                ? '/cart'
                : '/shop/personal-cart',
    },
);
